import React from 'react';

const AboutBrandSection = () => {
    return (
        <section id="about" className="relative py-10 md:py-15 lg:py-24 overflow-hidden bg-[#F8F4F0]">
            {/* Remove the background image and overlay - just solid cream */}

            {/* Content */}
            <div className="relative z-10 max-w-7xl mx-auto px-6">
                {/* Section Header */}
                <div className="text-center mb-12 md:mb-16">
                    <span className="text-[#DE0000] uppercase tracking-[0.2em] text-xs md:text-sm font-semibold mb-4 block">
                        OUR STORY
                    </span>
                    <h2 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-serif text-gray-900 max-w-4xl mx-auto leading-tight">
                        Real Dairy, Real Simple
                    </h2>
                </div>

                {/* 2-Column Grid - Video + Text */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
                    {/* Left Column - Video */}
                    <div className="relative group">
                        <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-video">
                            <iframe
                                width="100%"
                                height="100%"
                                src="https://www.youtube.com/embed/O947vBpUHi8?autoplay=0&rel=0&modestbranding=1&showinfo=0&iv_load_policy=3"
                                title="Frelish - Our Story"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                className="absolute inset-0 w-full h-full"
                            />
                        </div>
                    </div>

                    {/* Right Column - Brand Text */}
                    <div className="flex flex-col space-y-6">
                        <h3 className="text-2xl md:text-3xl lg:text-4xl font-serif text-gray-900 leading-tight">
                            At our dairy brand, we believe in bringing{' '}
                            <span className="text-[#DE0000]">real, honest dairy</span>{' '}
                            back to your table.
                        </h3>

                        <p className="text-gray-600 text-base md:text-lg leading-relaxed">
                            Our products are crafted with care in modern hygienic facilities,
                            ensuring taste, nutrition, and safety in every cup and bottle.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutBrandSection;